// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"171":"bfa874b0","412":"4f4a1af0","641":"0f9e5a04","735":"c27a0b03","820":"e9268408","875":"a73137f5","906":"eb8d734f"}[chunkId] + ".chunk.js";
};